import "./css/app.css"
import 'tippy.js/dist/border.css';
import "./css/fwd-loader.css"
import "./css/fonts.css"
import "./css/tailwind-build.css"
const Stimulus = require("stimulus");
window.application = Stimulus.Application.start();
window.Stimulus = Stimulus;
require("./js/stimulus/ui/modal.js");
require("./js/stimulus/ui/modal-trigger.js");
require("./js/stimulus/ui/tooltip.js");
require("./js/stimulus/ui/toggle.js");
require("./js/stimulus/forms/forminputs.js");
require("./js/stimulus/forms/forms.js");
require("./js/stimulus/forms/bind.js");
require("./js/app/line-chart.js");
require("./js/app/pie-chart.js");
require("./js/app/draw-chart.js");

